import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputDefault from '../../../../components/InputDefault/index.js';
import SelectDefault from '../../../../components/SelectDefault/index.js';
import LoadingCard from './LoadingCard';
import { CardContainer, CardHeader, CardBody, FormGroup } from './CardStyles';
import api from '../../../../services/api.js';
import moment from 'moment';

const CustomerCard = ({ idDm001, onDataUpdate }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [customerData, setCustomerData] = useState({
    idDm001: 0,
    nmCliente: '',
    nmFantasia: '',
    nrCpfCnpj: '',
    nrIeRg: '',
    dsEmail: '',
    dsEmail2: '',
    nmContato: '',
    inSituacao: '',
    inAprovado: '',
    dtAprovado: '',
    nrFone1: '',
    inWhatsapp1: '',
    nrFone2: '',
    inWhatsapp2: '',
    cdCliente: '',
    inEstadoCivil: '',
    nmProfissao: ''
  });

  const formatDate = (dateStr) => {
    if (dateStr === '' || dateStr === null) {
      return '';
    }
    return moment(dateStr).format('YYYY-MM-DD');
  };

  const applyCPFCNPJMask = (inputValue) => {
    const digitsOnly = inputValue.replace(/\D/g, '');
    let masked = '';

    if (digitsOnly.length <= 11) {
      // CPF
      masked = digitsOnly.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else {
      // CNPJ
      masked = digitsOnly.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    return masked;
  };

  useEffect(() => {
    const fetchCustomerData = async () => {
      if (!idDm001) return;
      
      try {
        setIsLoading(true);
        const customerResponse = await api.get(`customer?id=${idDm001}`);
        const data = customerResponse.data.data[0];
        
        if (customerResponse.status === 200) {
          const updatedData = {
            idDm001: data.ID_DM001,
            nmCliente: data.NM_CLIENTE,
            nmFantasia: data.NM_FANTASIA,
            nrCpfCnpj: applyCPFCNPJMask(data.NR_CPFCNPJ),
            nrIeRg: data.NR_IE_RG,
            dsEmail: data.DS_EMAIL,
            dsEmail2: data.DS_EMAIL2 || '',
            nmContato: data.NM_CONTATO,
            inSituacao: data.IN_SITUACAO,
            inAprovado: data.IN_APROVADO,
            dtAprovado: formatDate(data.DT_APROVADO),
            nrFone1: data.NR_FONE1,
            inWhatsapp1: data.IN_WHATSAPP1,
            nrFone2: data.NR_FONE2 || '',
            inWhatsapp2: data.IN_WHATSAPP2 || 'N',
            cdCliente: data.CD_CLIENTE,
            inEstadoCivil: data.IN_ESTADO_CIVIL,
            nmProfissao: data.NM_PROFISSÃO
          };
          
          setCustomerData(updatedData);
          onDataUpdate(updatedData);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error('Erro ao buscar dados do cliente:', error);
      }
    };

    fetchCustomerData();
  }, [idDm001, onDataUpdate]);

  const handleChange = (field, value) => {
    const updatedData = { ...customerData, [field]: value };
    setCustomerData(updatedData);
    onDataUpdate(updatedData);
  };

  const handleChangeCpfCnpj = (value) => {
    const maskedValue = applyCPFCNPJMask(value);
    handleChange('nrCpfCnpj', maskedValue);
  };

  if (isLoading) {
    return <LoadingCard title="Carregando Dados do Cliente..." />;
  }

  return (
    <CardContainer>
      <CardHeader>
        <h5>Dados do Cliente ({customerData.idDm001})</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col xs={12} md={3}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.nmCliente}
              onChange={(e) => handleChange('nmCliente', e.target.value)}
              Text={'Nome do Cliente'}
            />
          </Col>
          <Col xs={12} md={3}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.nmFantasia}
              onChange={(e) => handleChange('nmFantasia', e.target.value)}
              Text={'Nome Fantasia'}
            />
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.nrCpfCnpj}
              onChange={(e) => handleChangeCpfCnpj(e.target.value)}
              Text={'CPF/CNPJ'}
              maxLength={18}
            />
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.nrIeRg}
              onChange={(e) => handleChange('nrIeRg', e.target.value)}
              Text={'IE/RG'}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={3}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.dsEmail}
              onChange={(e) => handleChange('dsEmail', e.target.value)}
              Text={'E-mail'}
            />
          </Col>
          <Col xs={12} md={3}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.dsEmail2}
              onChange={(e) => handleChange('dsEmail2', e.target.value)}
              Text={'E-mail 2'}
            />
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.nmContato}
              onChange={(e) => handleChange('nmContato', e.target.value)}
              Text={'Contato'}
            />
          </Col>
          <Col xs={2}>
            <SelectDefault
              Width={'100%'}
              Margin={'10px 0px 15px 0px'}
              Text={'Situação'}
              value={`${customerData.inSituacao}`}
              onChange={(e) => handleChange('inSituacao', e.target.value)}>
              <option value="A">ATIVO</option>
              <option value="I">INATIVO</option>
            </SelectDefault>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.nrFone1}
              onChange={(e) => handleChange('nrFone1', e.target.value)}
              Text={'Telefone 1'}
            />
          </Col>
          <Col xs={2}>
            <SelectDefault
              Width={'100%'}
              Margin={'15px 0px 15px 0px'}
              Text={'WhatsApp 1'}
              value={`${customerData.inWhatsapp1}`}
              onChange={(e) => handleChange('inWhatsapp1', e.target.value)}>
              <option value="S">SIM</option>
              <option value="N">NÃO</option>
            </SelectDefault>
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.nrFone2}
              onChange={(e) => handleChange('nrFone2', e.target.value)}
              Text={'Telefone 2'}
            />
          </Col>
          <Col xs={2}>
            <SelectDefault
              Width={'100%'}
              Margin={'15px 0px 15px 0px'}
              Text={'WhatsApp 2'}
              value={`${customerData.inWhatsapp2}`}
              onChange={(e) => handleChange('inWhatsapp2', e.target.value)}>
              <option value="S">SIM</option>
              <option value="N">NÃO</option>
            </SelectDefault>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.cdCliente}
              onChange={(e) => handleChange('cdCliente', e.target.value)}
              Text={'Código do Cliente'}
              type={'number'}
            />
          </Col>
          <Col xs={2}>
            <SelectDefault
              Width={'100%'}
              Margin={'15px 0px 15px 0px'}
              Text={'Estado Civil'}
              value={`${customerData.inEstadoCivil}`}
              onChange={(e) => handleChange('inEstadoCivil', e.target.value)}>
              <option value="1">SOLTEIRO(A)</option>
              <option value="2">CASADO(A)</option>
              <option value="3">DIVORCIADO(A)</option>
              <option value="4">VIÚVO(A)</option>
            </SelectDefault>
          </Col>
          <Col xs={12} md={3}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.nmProfissao}
              onChange={(e) => handleChange('nmProfissao', e.target.value)}
              Text={'Profissão'}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={customerData.dtAprovado}
              onChange={(e) => handleChange('dtAprovado', e.target.value)}
              Text={'Data de Aprovação'}
              type={'date'}
            />
          </Col>
          <Col xs={2}>
            <SelectDefault
              Width={'100%'}
              Margin={'15px 0px 15px 0px'}
              Text={'Aprovado'}
              value={`${customerData.inAprovado}`}
              onChange={(e) => handleChange('inAprovado', e.target.value)}>
              <option value="S">SIM</option>
              <option value="N">NÃO</option>
            </SelectDefault>
          </Col>
        </Row>
      </CardBody>
    </CardContainer>
  );
};

export default CustomerCard;
